import { Object3D, Mesh } from 'three';

export const isMesh = (object: Object3D): object is Mesh => {
  // @ts-ignore
  return object.isMesh === true;
}
